import axiosInstance from "../config/axios";

export function documentCategoryForListingPdf(agreementType, dealType) {
  const type = String(agreementType || "").toLowerCase();
  const deal = String(dealType || "").toLowerCase();
  if (
    type.includes("landlord") ||
    type.includes("210") ||
    deal.includes("lease")
  ) {
    return "lease-listing";
  }
  return "sale-listing";
}

export function documentItemForListingPdf() {
  // Checklist uses one "Listing agreement" slot for Form 200/210/520/594.
  return "listing-agreement";
}

function fileToBase64Chunk(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const result = String(reader.result || "");
      const base64 = result.includes(",") ? result.split(",")[1] : result;
      resolve(base64 || "");
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

export async function saveListingPdfToDocuments({
  listingId,
  file,
  agreementType,
  dealType,
}) {
  if (!listingId || !file) return;
  const category = documentCategoryForListingPdf(agreementType, dealType);
  const itemId = documentItemForListingPdf(agreementType);
  // Stay under nginx's ~1mb body limit (avoids 413 on large DigiSign PDFs).
  const CHUNK_BYTES = 400 * 1024;
  const totalChunks = Math.max(1, Math.ceil(file.size / CHUNK_BYTES));
  const uploadId = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;

  for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex += 1) {
    const start = chunkIndex * CHUNK_BYTES;
    const end = Math.min(file.size, start + CHUNK_BYTES);
    const chunkBase64 = await fileToBase64Chunk(file.slice(start, end));
    await axiosInstance.post(
      `/listing-documents/${listingId}/files/chunk`,
      {
        uploadId,
        category,
        itemId,
        fileName: file.name || "document.pdf",
        mimeType: file.type || "application/pdf",
        chunkIndex,
        totalChunks,
        chunkBase64,
        fromPdfExtract: "1",
        skipFormCheck: "1",
        skipFormMatch: "true",
        source: "listing-pdf-parse",
      },
      { timeout: 180000 },
    );
  }
}
